import React from 'react'
import {
    List,
    Datagrid,
    TextField,
    TextInput,
    Filter,
    EditButton
} from 'react-admin'


const PostFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Buscar" source="search" alwaysOn />
    </Filter>
);


export const FichaTecnicaList = props => (
    <List
        {...props}
        filters={<PostFilter />}
        sort={{ field: 'name', order: 'ASC' }}
        exporter={false} 
    >
        <Datagrid>
            <TextField source="name" />
            <TextField source="description" />
            <EditButton label={"Editar"} />
        </Datagrid>
    </List>
);
